import HttpService from '../services/HttpService';

export const SET_LOADING = 'billing_set_loading';
export const SET_HARD_LOADING = 'billing_set_hard_loading';
export const SET_LOADING_BATCH = 'billing_set_loading_batch';
export const SET_DEFAULT_FILTER = 'billing_set_default_filter';
export const UPDATE_LEGS_ONLY = 'billing_update_legs_only';
export const UPDATE_LEGS = 'billing_update_legs';
export const UPDATE_ONE_LEG = 'billing_update_one_leg';
export const UPDATE_BATCH = 'billing_update_batch';
export const SELECT_LEG = 'billing_select_leg';
export const CHANGE_CHECKED_LEGS = 'billing_change_checked_legs';
export const CHANGE_FILTER = 'billing_change_filter';
export const SET_PAGE = 'billing_set_page';

export const getLegs = (options = null) => {
  options = options || {};
  if (!options.hasOwnProperty('normalLoading')) {
    options.normalLoading = true;
  }
  if (!options.hasOwnProperty('hardLoading')) {
    options.hardLoading = false;
  }

  return (dispatch, getState) => {
    if (options.hardLoading) {
      dispatch({ type: SET_HARD_LOADING, payload: true });
    }
    if (options.normalLoading) {
      dispatch({ type: SET_LOADING, payload: true });
    }

    const state = getState();

    return fetchLegs({
      ...state.BillingBatchReducer.filterSettings,
      page: state.BillingBatchReducer.page,
      batchId: state.BillingBatchReducer.batch.id,
    }).then((data) => {
      dispatch({ type: UPDATE_LEGS, payload: data });
      if (options.hardLoading) {
        dispatch({ type: SET_HARD_LOADING, payload: false });
      }
      if (options.normalLoading) {
        dispatch({ type: SET_LOADING, payload: false });
      }
    });
  };
};

export const getLegById = (legId) => {
  return (dispatch, getState) => {
    // dispatch({ type: SET_HARD_LOADING, payload: true });
    dispatch({ type: SET_LOADING, payload: true });

    return fetchLegOne(legId).then((data) => {
      dispatch({ type: UPDATE_ONE_LEG, payload: data });
      dispatch({ type: SET_HARD_LOADING, payload: false });
      dispatch({ type: SET_LOADING, payload: false });
    });
  };
};

export const getBatch = (id, setFilter) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({ type: SET_LOADING_BATCH, payload: true });
    dispatch({ type: SET_DEFAULT_FILTER });

    return fetchBatch(id).then((data) => {
      dispatch({ type: UPDATE_BATCH, payload: data });
      dispatch({ type: SET_LOADING_BATCH, payload: false });

      const newFilterData = {
        ...state.BillingBatchReducer.filterSettings,
      };

      if (setFilter) {
        newFilterData.date = data.batch.start_date;
      }

      dispatch(changeFilter(newFilterData, true));
    });
  };
};

export const changePage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
    dispatch(getLegs());
  };
};

export const enableLoading = () => {
  return (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
  };
};

export const changeFilter = (filterSettings, hardLoading = false) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_FILTER, payload: filterSettings });
    dispatch({ type: SET_PAGE, payload: 0 });
    dispatch(getLegs({ hardLoading }));
  };
};

export const updateLegs = (hardLoading = false) => {
  return (dispatch) => {
    dispatch(getLegs({ hardLoading }));
  };
};

export const fetchLegOne = (legId) => {
  return HttpService.post(`/admin/billing-batch-legs/get-one/${legId}`)
    .then((response) => response.json())
    .then((data) => data);
};

export const fetchLegs = (filterSettings) => {
  return HttpService.post(`/admin/billing-batch-legs/get`, filterSettings)
    .then((response) => response.json())
    .then((data) => data);
};

export const fetchBatch = (batchId) => {
  return HttpService.get(`/admin/billing-batch/get/${batchId}`)
    .then((response) => response.json())
    .then((data) => data);
};
